module.exports = __webpack_public_path__ + "static/media/videocall_ringtone.9a765f88.mp3";